export const counter = {
  input: {
    countingVariable: "Elements to count"
  },
  output: {
    countingResult: "Response"
  }
};
